<template>
  <div class="lp3-payment">
    <lp-payment
      :loading="loading"
      :selected-product="selectedProduct"
      @lpUserAction="$emit('lpUserAction', $event)"
      @setLoading="$emit('setLoading', $event)"
    />
  </div>
</template>

<script>
import LpPayment from '@/components/Lp/LpPayment.vue'

export default {
  name: 'Lp3Payment',
  components: {
    LpPayment,
  },
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    selectedProduct: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {},
}
</script>
